import { resolveImageUrl, DEFAULT_LOGO, DEFAULT_CARD_BG } from './imageDefaults';
import { buildCardBackground } from './cardSurface';
import { resolveTemplateColor } from './templateColors';

export function getStoreStyle(store) {
  if (!store) {
    return {
      mainColor: '#4f6ef7',
      textColor: '#f0f4ff',
      labelColor: '#c8d4ff',
      imageUrl: DEFAULT_CARD_BG,
      logoUrl: DEFAULT_LOGO,
    };
  }
  return {
    mainColor: resolveTemplateColor(store.mainColor, 'mainColor'),
    textColor: resolveTemplateColor(store.textColor, 'textColor'),
    labelColor: resolveTemplateColor(store.labelColor, 'labelColor'),
    imageUrl: resolveImageUrl(store.backgroundUrl, DEFAULT_CARD_BG),
    logoUrl: resolveImageUrl(store.logoUrl, DEFAULT_LOGO),
  };
}

export function getStoreCardStyle(store) {
  const style = getStoreStyle(store);
  return {
    backgroundColor: style.mainColor,
    color: style.textColor,
    backgroundImage: buildCardBackground({ imageUrl: style.imageUrl, cardStyle: 'plastic' }, true),
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  };
}
